import React, { Component } from 'react';
import { flow } from 'lodash/fp';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { withStyles } from '@material-ui/core/styles';

import Collapse from '@material-ui/core/Collapse';

import { stopRecord, editRecord } from '../data/redux/thunks';
import { withSelectors, records, topics } from '../data/selectors';

import FloatingTopicAdd from '../components/FloatingTopicAdd';
import RecordList from '../components/RecordList';
import TopBar from '../components/TopBar';
import RecordsFilter from '../components/RecordsFilter';
import ToggleButton from '../components/ToggleButton';
import { Paragraph } from '../components/Typography';
import { PrimaryButton } from '../components/Forms';
import withLoading from '../components/withLoading';

const RECORDS_PAGE_SIZE = 35;

const styles = theme => ({
  recordList: {
    marginBottom: theme.spacing(1),
  }
});

class Records extends Component {

  state = {
    showFilter: false,
    showGaps: false,
    filterTopics: false,
    topicsToShow: {},
    limit: RECORDS_PAGE_SIZE,
    showNotes: false,
  }

  toggleFilter = () => {
    const { showFilter } = this.state;
    this.setState({ showFilter: !showFilter });
  }

  onShowGapsChanged = (showGaps) => {
    this.setState({ showGaps });
  }

  onShowNotesChanged = (showNotes) => {
    this.setState({ showNotes });
  }

  onFilterTopicsChanged = (filterTopics) => {
    this.setState({ filterTopics });
  }

  onTopicsToShowChanged = (topicId) => (show) => {
    const { topicsToShow } = this.state;
    topicsToShow[topicId] = show;
    this.setState({ topicsToShow });
  }

  onSelect = (record) => {
    this.props.editRecord(record)
  }

  showMore = () => {
    const { limit } = this.state;
    this.setState({ limit: limit + RECORDS_PAGE_SIZE })
  }

  render() {
    console.log('Records', this.props);
    const { records, topics, classes, stopRecord } = this.props;
    const { showFilter, showGaps, filterTopics, topicsToShow, limit, showNotes } = this.state;

    const filteredRecords = records.filter(r => filterTopics ? topicsToShow[r.type] : true)
    const shownRecords = filteredRecords.filter((x, i) => i < limit);
    const hidingSomeRecords = shownRecords.length !== filteredRecords.length;

    return (
      <React.Fragment>

        <TopBar icon={<ToggleButton onClick={this.toggleFilter} toggled={showFilter}/>}>Records</TopBar>

        <Collapse in={showFilter}>
          <RecordsFilter
            showGaps={showGaps}
            onShowGapsChanged={this.onShowGapsChanged}
            filterTopics={filterTopics}
            onFilterTopicsChanged={this.onFilterTopicsChanged}
            topicsToShow={topicsToShow}
            onTopicsToShowChanged={this.onTopicsToShowChanged}
            topics={topics}
            withNotes={true}
            showNotes={showNotes}
            onShowNotesChanged={this.onShowNotesChanged}
          />
        </Collapse>

        <RecordList
          className={classes.recordList}
          records={shownRecords}
          topics={topics}
          onSelect={this.onSelect}
          onStop={stopRecord}
          showGaps={showGaps}
          showNotes={showNotes}
        />

        {
          hidingSomeRecords &&
          <div style={{ display: 'flex', 'justifyContent': 'center' }}>
            <PrimaryButton variant="text" onClick={this.showMore}>Show more</PrimaryButton>
          </div>
        }

        {
          shownRecords.length === 0 &&
          (filterTopics ?
            <Paragraph>No matching results</Paragraph> :
            <Paragraph>No records yet</Paragraph>
          )
        }

        <FloatingTopicAdd />

      </React.Fragment>
    );
  }
}

Records.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default flow([
  withLoading(props => props.records === null),
  withStyles(styles),
  connect(withSelectors({ records, topics }), { stopRecord, editRecord }),
  withRouter,
])(Records);
